import Input from "sap/m/Input";
import InputRenderer from "sap/m/InputRenderer";

/**
 * @namespace akademika.akamont.customControls
 */
export default class PasswordInput extends Input {
  private _isShown = false;

  init(): void {
    super.init();
    this.setShowValueHelp(true);
    this.setValueHelpIconSrc("sap-icon://show");
    this.attachValueHelpRequest(this.toggleReveal);
    this.setType("Password");
  }

  static renderer = InputRenderer;

  toggleReveal() {
    this._isShown = !this._isShown;

    if (this._isShown) {
      this.setType("Text");
      this.setValueHelpIconSrc("sap-icon://hide");
    } else {
      this.setType("Password");
      this.setValueHelpIconSrc("sap-icon://show");
    }
    this.setValue(this.getValue()); // This fixes the following bug: if you enter the password and immediately click "reveal" icon while input field is active, the binding was not updated and user experienced a login error.
  }
}
